import React from "react";
import * as styled from "./styled";

const BackwardsNavigation = ({ onClick }) => {
  return (
    <styled.BackwardsNavigationWrapper onClick={() => onClick()}>
      <styled.ArrowIconWrapper>{"<"}</styled.ArrowIconWrapper>
      Back
    </styled.BackwardsNavigationWrapper>
  );
};

export default BackwardsNavigation;
